import React, { useEffect, useRef } from "react";
import ExternalActionsTable from "src/components/ExternalActionsTable";
import SelectForm from "../../../components/ComponentesFormularios/SelectForm";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import { Colors } from "../../../assets/colors/Colors";
import AgGridTable from "src/components/AgGridTable";
import Tooltip from "@mui/material/Tooltip";
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import { CalendarForm, CalendarFormRange } from "../../../components/ComponentesFormularios/CalendarForm";
import { modalCRUDService } from "../../../services/modalCRUDService";
import { GlobalConstants } from "../../../data/GlobalConstants";
import { useDispatch, useSelector } from "react-redux";
import ImagePicker from "src/components/ComponentesFormularios/ImagePicker";
import TransfertList from "../../../components/TransferList";
import AutocompleteForm from "src/components/ComponentesFormularios/Autocomplete";
import { alertQuestionService } from "../../../services/alertQuestionService";
import {
    convertToString,
    dateToStringFormat, getDateTime,
    getFechaToCalendarRange,
    validarEspaciosEnBlanco,
    validArray,
    currencyFormatter
} from "../../../util/functions";
import { FormProvider, useForm, useFormContext, useWatch } from "react-hook-form";
import { isEmpty, isObject } from "../../../util/is";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import {
    classResponsiveForm,
    classResponsiveFormDoubleWidthHeader,
    classResponsiveFormDoubleWidth, classResponsiveFormWidthHeader, ERRORFIELDREQUIRED,
    optionsEstados,
    optionsYesNo
} from "../../../data/ConstantForm";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";
import { crearActivosService } from "src/services/apiCrearActivos";
import { preciosService } from "src/services/apiPrecios";
import Precios from "src/views/pages/gestion-maestros/precios/Precios";
import { Button } from "react-bootstrap";
import { useState } from "react";
const columnsDef = [
    { headerName: 'ID', field: "id", resizable: true, sortable: false, filter: false, width: 10, hide: true },
    { headerName: 'ID Nivel', field: "nivel", resizable: true, sortable: true, filter: true, width: 40 },
    // { headerName: 'Nivel', field: "nivel", resizable: true, sortable: true, filter: true, width: 50 },
    { headerName: 'ID Oficina', field: "ofiVentas", resizable: true, sortable: true, filter: true, width: 40 },
    // { headerName: 'Oficina', field: "oficina", resizable: true, sortable: true, filter: true, width: 50 },
    { headerName: 'ID Agente', field: "agenteComercial", resizable: true, sortable: true, filter: true, width: 40 },
    // { headerName: 'Agente', field: "agente", resizable: true, sortable: true, filter: true, width: 50 },
    { headerName: 'ID Canal', field: "canal", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'SubCanal', field: "subCanal", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'Tipologia', field: "tipologia", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'Producto', field: "producto", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'Precio', field: "precio", resizable: true, sortable: true, filter: true, width: 40},
    { headerName: 'Fecha Ini', field: "fechaIni", resizable: true, sortable: true, filter: true, width: 40,
    cellRendererSelector: () => ({
        component: 'fechaIni',
    }) },
    { headerName: 'Fecha Fin', field: "fechaFin", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'Estado', field: "estado", resizable: true, sortable: true, filter: true, width: 40, cellStyle: {fontWeight: 'bold'},
        cellRendererSelector: () => ({
            component: 'estado',
        }) },
    { headerName: 'Fila', field: "fila", resizable: true, sortable: true, filter: true, width: 40 },
]


const TableExcel = ({properties}) => {

    const [stateButton, setStateButton] = useState(false);
    const { data, referencia } = properties
    const dispatch = useDispatch();
    const authState = useSelector(state => state.auth)
    const { idUsuario } = authState;    
    const tableRef = useRef(null);
    const newsRef = useRef(null);
    const updatesRef = useRef(null);
    const errorsRef = useRef(null);
    const existenteRef = useRef(null);
    const duplicateRef = useRef(null);

    const modalSubmit = () =>{

    }

    const guardarExcel =  (jsonExcel) => {

        alertQuestionService.showAlert({
            title: `Guardar Reglas de Precios`, question: `¿Estás seguro de guardar?`,
            targetPrecios: {error: data.contError, existente: data.contExistente},
             message: `Ten en cuenta que no se guardarán ${data.contError} registros que presentan error y ${data.contExistente} ya existentes.`,
            

            actionBtnAceptar: async () =>{
                alertQuestionService.clear(); 
                let arrSave = []
                setStateButton(true)
                tableRef.current.api.forEachNodeAfterFilter( nodo => {
                    if (nodo.data.estado == 'Nuevo' || nodo.data.estado == 'Actualizar' || nodo.data.estado == 'Actualizar con parche'){
                        nodo.data.idUsuario = idUsuario
                        arrSave.push(nodo.data)
                    }
                })

                if(arrSave.length == 0){
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: 'Ninguna regla fue guardada.' } });
                    modalCRUDService.clear()
                }else{
                    try {
                        let res = await preciosService.guardarCargueExcel({ data: arrSave, jsonExcel: jsonExcel})
                        const { status, msg, data: datos } = res
                        if (status) {
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.msg } });
                            modalCRUDService.clear()
                            
                            for (const el of datos) {
                                let resId = await preciosService.getFilteredData({data: el}, false)
                                let arrAux = []
            
                                const { status, data} = resId
            
                                referencia.current.api.forEachNodeAfterFilter(nodo => {
            
                                    if(nodo.data.id == data[0]?.id){
                                        nodo.setDataValue("precio", data[0]?.precio);
                                        nodo.setDataValue("dtValidoInicial", data[0]?.dtValidoInicial);
                                        nodo.setDataValue("dtValidoFinal", data[0]?.dtValidoFinal);
                                        arrAux.push(data[0]?.id)
                                    }
                                })
            
                                if(arrAux.length == 0){
                                    referencia.current.api.applyTransaction({
                                        add: [{
                                            id: data[0]?.id,
                                            idNivel: data[0]?.idNivel,
                                            nivel: data[0]?.nivel,
                                            idOficina: data[0]?.idOficina,
                                            oficina: data[0]?.oficina,
                                            idAgente: data[0]?.idAgente,
                                            agente: data[0]?.agente,
                                            idCanal: data[0]?.idCanal,
                                            canal: data[0]?.canal,
                                            idSubCanal: data[0]?.idSubCanal,
                                            subCanal: data[0]?.subCanal,
                                            idTipologia: data[0]?.idTipologia,
                                            tipologia: data[0]?.tipologia,
                                            idProducto: data[0]?.idProducto,
                                            producto: data[0]?.producto,
                                            precio: data[0]?.precio,
                                            dtValidoInicial: data[0]?.dtValidoInicial,
                                            dtValidoFinal: data[0]?.dtValidoFinal,
                                            auditor: data[0]?.auditor,
                                            fechaAuditoria: data[0]?.fechaAuditoria
                                        }]
                                    })
                                }
                            }                
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: `${data.contNew > 0 ? `Creados: ${data.contNew},   ` : '' } ${data.contUpdate > 0 ? `Actualizados: ${data.contUpdate}` : ''}`  } });
                            
                        }
                        else {
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: 'Ha ocurrido un error' } });
                            
                        }
                    } catch (error) {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error } });
                        console.log(error)
                    }
                }
            },
            actionBtnCancelar: () => alertQuestionService.clear(),
            type: GlobalConstants.alertInfo
        })
    }

    useEffect(() => {
        newsRef.current.innerText =  data.contNew == undefined ? ' 0' : ` ${data.contNew}`
        updatesRef.current.innerText = data.contUpdate == undefined ? ' 0' : ` ${data.contUpdate}`
        errorsRef.current.innerText = data.contError == undefined ? ' 0' : ` ${data.contError}`
        existenteRef.current.innerText = data.contExistente == undefined ? ' 0' : ` ${data.contExistente}`
        duplicateRef.current.innerText = data.contDuplicate == undefined ? ' 0' : ` ${data.contDuplicate}`
    }, [])

    const onGridReady = (params) => {
        
        const allColumns = [];
        params.columnApi.getAllColumns().map( column =>{
            allColumns.push(column.colId)
        })
        params.columnApi.autoSizeColumns(allColumns, false);
    }

    const CustomCellEstado = (params) => {

        if(params.data.estado == 'Error'){
            return <span style={{color: Colors.ROJO_PASTEL, fontWeight: 'bold'}}>{params.value}</span>
        }else if(params.data.estado == 'Regla existente' || params.data.estado == 'Regla duplicada'){
            return <span style={{color: '#4040FF', fontWeight: 'bold'}}>{params.value}</span>
        }else if(params.data.estado == 'Actualizar con parche'){
            return <span style={{color: Colors.ORANGE, fontWeight: 'bold'}}>{params.value}</span>
        }else{
            return <span>{params.value}</span>
        }
    }

    const CustomCellFecha = (params) => {
        const flagData = params.data.fechaIni
        if(flagData.includes('Fecha inválida')){
            return <span className="d-flex align-items-center" style={{color: Colors.ROJO_PASTEL, fontWeight: 'bold'}}>{params.value}</span>
        }else{
            return <span>{params.value}</span>
        }
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex justify-content-between align-items-center w-75 pl-3">
                    <div>
                        <strong>Nuevos:</strong>
                        <span ref={newsRef} style={{fontSize: 20, color: '#64DF38', fontWeight: 'bold'}}> 0</span>
                    </div>
                    <div>
                        <strong>Pendientes por Actualizar:</strong>
                        <span ref={updatesRef} style={{fontSize: 20, color: '#FFC40C', fontWeight: 'bold'}}> 0</span>
                    </div>
                    <div>
                        <strong>Errores:</strong>
                        <span ref={errorsRef} style={{fontSize: 20, color: 'red', fontWeight: 'bold'}}> 0</span>
                    </div>
                    <div>
                        <strong>Reglas Existentes:</strong>
                        <span ref={existenteRef} style={{fontSize: 20, color: '#4040FF', fontWeight: 'bold'}}> 0</span>
                    </div>
                    <div>
                        <strong>Reglas Duplicadas:</strong>
                        <span ref={duplicateRef} style={{fontSize: 20, color: '#4040FF', fontWeight: 'bold'}}> 0</span>
                    </div>
                </div>
                <div className={`d-flex align-items-center ${stateButton ? 'is-disabled' : ''}`}>
                    {/* <Tooltip title="Cancelar" aria-label="cancelar">
                        <a onClick={() => { modalCRUDService.clear() }} className="icon-container-actions d-flex">
                            <div style={{ backgroundColor: Colors.RED_SWITCH_INACTIVE }} />
                            <i style={{ color: Colors.RED_SWITCH_INACTIVE }} className="fas fa-times fa-2x" />
                        </a>
                    </Tooltip> */}
                    <Tooltip title="Guardar Producto" aria-label="guardar-producto" >
                        <a className="icon-container-actions d-flex "
                        onClick={() => guardarExcel(data.JsonExcel) }>
                            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                            <i style={{color: Colors.COLOR_GREEN_DARK}} className="far fa-save fa-2x"/>
                        </a>
                    </Tooltip>
                </div>
            </div>
            <AgGridTable
                referencia={tableRef}
                columnDef={columnsDef}
                dataList={data?.rows || []}
                // acciones={AccionesReferencias}
                rowSelection={'multiple'}
                avatarKey="nombre"
                frameworkComponents={{
                    estado: CustomCellEstado,
                    fechaIni: CustomCellFecha
                }}
                onGridReady={onGridReady}
            />
        
        </>
    )
}
export default TableExcel